export default {
  serverTime: 0,
  diffServerTime: 0,
  isOpenRollBook: false,
  isOpenVoiceRequest: false,
  isOpenControlMenu: false,
}
